"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const alarm_1 = require("../../../../@inax/alarm");
const translate_1 = require("../../../../@inax/translate");
const alarm_list_component_1 = require("./alarm-list.component");
let HistoricalAlarmListComponent = class HistoricalAlarmListComponent extends alarm_list_component_1.AlarmListComponent {
    /**
     *
     */
    constructor(inaxAlarm, inaxTranslate) {
        super(inaxAlarm, inaxTranslate);
        this.title = "Historical";
    }
    updateAlarms() {
        return __awaiter(this, void 0, void 0, function* () {
            this.numberOfAlarms = yield this._inaxAlarm.numberOfHistoricalAlarmsAsync(this._filter);
            if (this.numberOfAlarms > 0) {
                this._inaxAlarm.history(this._filter, this._inaxTranslate.defaultLanguage, this._inaxTranslate.language, this.skip, this.entriesPerPage, false, this._currentSortOrder).subscribe(a => this.alarms = a);
            }
        });
    }
};
HistoricalAlarmListComponent = __decorate([
    core_1.Component({
        selector: 'historical-alarm-list',
        templateUrl: './@inax/alarmUi/src/alarmList/alarm-list.component.html',
        styleUrls: ['./@inax/alarmUi/src/alarmList/alarm-list.component.css']
    }),
    __metadata("design:paramtypes", [alarm_1.InaxAlarmService,
        translate_1.InaxTranslateService])
], HistoricalAlarmListComponent);
exports.HistoricalAlarmListComponent = HistoricalAlarmListComponent;
